import type { Zone } from '../types/zones'
import { createContext } from 'react'

export interface UserContextType {
  id: string | null | undefined
  canManageUsers: boolean
  canViewAllZones: boolean
  zones: Zone[]
  selectedZone: Zone | null
  isLoading: boolean
  errorMessage: string | null
}

export const defaultUserContext: UserContextType = {
  id: null,
  canManageUsers: false,
  canViewAllZones: false,
  zones: [],
  selectedZone: null,
  isLoading: true,
  errorMessage: null,
}

export const UserContext = createContext<UserContextType>(defaultUserContext)
